import { Component, OnInit } from '@angular/core';
// Services
import { ElasticService } from './../../services/elastic';
// External
import { Club } from './../../models/club';

import * as lodash from 'lodash';
import { ApiService } from './../../services/api';
import { DatePipe } from '@angular/common';


@Component({
    templateUrl: './term.condition.component.html',
    selector: 'app-term-condition'
})
export class TermConditionComponent implements OnInit {
    public imageLoader = true;
    
    public master = {
        text: ''
    };
    ngOnInit(): void {
        this.apiService.object("currentVersion/").then((result) => {
            if (result.tac){
                this.master.text = result.tac
            }
            this.imageLoader =false
            
        })
    }


    constructor(private apiService: ApiService) {

    }
    public submit() {
        this.apiService.set("currentVersion/tac", this.master.text)
    }
}
